import React, { useEffect, useState } from "react";
import t1 from "../../../images/t-1.png";
import t2 from "../../../images/t-2.png";
import t3 from "../../../images/t-3.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  generate_quiz,
  Quizcms,
  Subtopic,
  User_Progress,
  user_token,
} from "../../../redux/authslice";

// import { Flip, toast } from "react-toastify";

const QuizGenerator = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const progressData = useSelector((state) => state.counter.progressData);
  const userToken = useSelector((state) => state.counter.userToken);
  const QuizCmsData = useSelector((state) => state.counter.QuizCmsData);
  const topicdata = useSelector((state) => state.counter.topicdata);

  const [subtopic, setSubtopic] = useState([]);
  // const [topic, setTopic] = useState([]);
  const [errors, setErrors] = useState({});

  const [filteroption, setFilterOption] = useState({
    subject: "",
    levelOfStudy: "",
    examBoard: "",
    topic: "",
    subtopic: "",
    courseLevel: "",
    numberOfQuestions: "",
  });

  const filterOptions = {
    subject: topicdata ? topicdata?.data?.map((ele) => ele.subject) : [],
    levelOfStudy: QuizCmsData.levelofstudy
      ? QuizCmsData.levelofstudy.split("\n")
      : [],
    examBoard: QuizCmsData.examboard ? QuizCmsData.examboard.split("\n") : [],
    topic: topicdata?.topic_detail?.topic
      ? topicdata?.topic_detail?.topic?.map((ele) => ele)
      : [],
    subtopic,
    courseLevel: topicdata
      ? topicdata?.data
          ?.filter((ele) => ele.subject === filteroption?.subject)
          ?.flatMap((ele) => ele.course_level)
      : [],
    numberOfQuestions: QuizCmsData.Numbers
      ? QuizCmsData.Numbers.split("\n")
      : [],
  };

  const filterDataBySubject = (subject) => {
    const matchedData = topicdata?.data?.find(
      (item) => item?.subject?.toLowerCase() === subject?.toLowerCase()
    );

    // setTopic(matchedData?.topic);
    return matchedData?.subtopic || {};
  };

  const handleSelectChange = (e, key) => {
    const value = e.target.value;

    setFilterOption((prevState) => ({
      ...prevState,
      [key]: value,
    }));

    if (errors[key]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [key]: "",
      }));
    }

    // if (key === "subject") {
    //   filterDataBySubject(value);
    //   setSubtopic([]);
    //   setFilterOption((prevState) => ({
    //     ...prevState,
    //     topic: "",
    //     subtopic: "",
    //   }));
    // }

    if (key === "topic") {
      const subjectData = filterDataBySubject(filteroption?.subject);
      setSubtopic(subjectData[value] || []);
      setFilterOption((prevState) => ({
        ...prevState,
        subtopic: "",
      }));
    }
  };

  const validate = () => {
    const requiredFields = [
      "levelOfStudy",
      "subject",
      "examBoard",
      "topic",
      "courseLevel",
      "numberOfQuestions",
    ];

    const newErrors = {};

    if (filteroption.subject.toLowerCase().includes("english")) {
      const filteredFields = requiredFields.filter(
        (field) => field !== "courseLevel"
      );
      filteredFields.forEach((field) => {
        if (!filteroption[field]) {
          newErrors[field] = "Required";
        }
      });
    } else {
      requiredFields.forEach((field) => {
        if (!filteroption[field]) {
          newErrors[field] = "Required";
        }
      });
    }

    return newErrors;
  };

  const HandleGenrate = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    } else if (userToken.used_token === userToken.total_token) {
      navigate("/paymentsubscription");
    } else {
      dispatch(generate_quiz({ filteroption, navigate, dispatch }));
    }
  };

  useEffect(() => {
    dispatch(User_Progress(dispatch));
    dispatch(user_token(dispatch));
    dispatch(Quizcms(dispatch));
    dispatch(Subtopic({ filteroption }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(Subtopic({ filteroption }));
  }, [filteroption?.subject, filteroption.examBoard]);

  return (
    <>
      <section className="my-progress">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="progres-all">
                <ul>
                  <li>
                    <p className="progress-p">My progress</p>
                  </li>
                  <li>
                    <div className="progress-media">
                      <img src={t1} alt="" />
                      <div className="progress-media-right">
                        <p className="progress-media-right-1">
                          In progress quizzes
                        </p>
                        <p className="progress-media-right-2">
                          {progressData?.in_progress_quizzes}
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="progress-media">
                      <img src={t2} alt="" />
                      <div className="progress-media-right">
                        <p className="progress-media-right-1">
                          Completed quizzes
                        </p>
                        <p className="progress-media-right-2">
                          {progressData?.completed_quizzes}
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="progress-media">
                      <img src={t3} alt="" />
                      <div className="progress-media-right">
                        <p className="progress-media-right-1">Score over 90%</p>
                        <p className="progress-media-right-2">
                          {progressData?.over_90_rate !== undefined
                            ? progressData.over_90_rate.toFixed(0)
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <button
                      className="Scores-over"
                      onClick={() => navigate("/history")}
                    >
                      View quiz history
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="all-dasboard">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="info-box" style={{ marginTop: "20px" }}>
                <i className="fas fa-info-circle info-icon"></i>&nbsp;
                <span>
                  {" "}
                  Some quizzes may take a couple of minutes to generate, thank
                  you for your patience!
                </span>
              </div>

              <div className="create-quiz">
                <p className="create-quiz-p">Create your quiz</p>
                <button className="Generate-quiz" onClick={HandleGenrate}>
                  Generate quiz
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="quiz-border">
                <div className="row">
                  <div className="col-lg-5">
                    <div className="quiz-border-left">
                      <div className="space-quiz">
                        <p className="space-quiz-p1">Filters</p>
                      </div>
                      {Object.keys(filterOptions)?.map((key) => {
                        if (
                          filteroption.subject
                            .toLowerCase()
                            .includes("english") &&
                          key === "courseLevel"
                        ) {
                          return null;
                        }

                        return (
                          <div className="space-quiz" key={key}>
                            <label htmlFor="" className="space-quiz-label">
                              {key
                                .replace(/([A-Z])/g, " $1")
                                .toLowerCase()
                                .replace(/^./, (str) => str.toUpperCase())}{" "}
                              &nbsp;
                              {key === "subtopic" ? "(Optional)" : ""}
                            </label>
                            <select
                              name=""
                              id=""
                              value={filteroption.option}
                              onChange={(e) => handleSelectChange(e, key)}
                              className={`form-control ${
                                errors[key] ? "is-invalid" : ""
                              }`}
                            >
                              <option value="">Select option</option>
                              {filterOptions[key]?.map((option, index) => (
                                <option value={option} key={index}>
                                  {option}
                                </option>
                              ))}
                            </select>
                            {errors[key] && (
                              <div className="invalid-feedback">
                                {errors[key]}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="col-lg-7">
                    <div className="quiz-border-right">
                      <div className="space-quiz">
                        <p className="space-quiz-p1">Instructions</p>
                      </div>
                      <div className="space-quiz">
                        <p className="space-quiz-p2">Subject:</p>
                        <p className="space-quiz-p3">
                          Select your chosen subject (e.g.{" "}
                          {filterOptions.subject?.join(", ") ||
                            "Maths, English"}
                          ).
                        </p>
                      </div>
                      <div className="space-quiz">
                        <p className="space-quiz-p2">Level of study:</p>
                        <p className="space-quiz-p3">
                          Select your current level from the dropdown (e.g.{" "}
                          {filterOptions.levelOfStudy?.join(", ") ||
                            "GCSE, A-Level"}
                          ).
                        </p>
                      </div>
                      <div className="space-quiz">
                        <p className="space-quiz-p2">Exam board:</p>
                        <p className="space-quiz-p3">
                          Select your exam board (e.g.{" "}
                          {filterOptions.examBoard?.join(", ") ||
                            "AQA, Edexcel"}
                          ).
                        </p>
                      </div>
                      <div className="space-quiz">
                        <p className="space-quiz-p2">Topic:</p>
                        <p className="space-quiz-p3">
                          Select your desired topic (e.g.{" "}
                          {filterOptions.topic?.join(", ") ||
                            "Algebra, Geometry"}
                          ).
                        </p>
                      </div>
                      <div className="space-quiz">
                        <p className="space-quiz-p2">Course level:</p>
                        <p className="space-quiz-p3">
                          Select your current course level (e.g.{" "}
                          {filterOptions.courseLevel?.join(", ") ||
                            "Foundation, Higher"}
                          ).
                        </p>
                      </div>
                      <div className="space-quiz">
                        <p className="space-quiz-p2">Number of questions:</p>
                        <p className="space-quiz-p3">
                          Select the number of questions you would like in your
                          quiz.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default QuizGenerator;
